// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.0002 7.95517C10.0243 4.6621 12.7012 2 16 2C18.0462 2 19.8517 3.02433 20.934 4.5853C21.2698 4.4194 21.6575 4.19395 22.0603 3.94764L23.582 3.01714V4.80078C23.582 6.17104 23.2996 7.21126 22.8983 8.00246C22.6171 8.55688 22.29 8.96422 22 9.26187V10C22 17.1797 16.1797 23.0004 8.99999 23.0004C6.55063 23.0004 4.25667 22.3221 2.2991 21.1425L0.0490957 19.7866L2.63116 19.303C3.65598 19.1111 4.63303 18.7832 5.54295 18.3384C2.2211 16.3228 0 12.6716 0 8.49986C0 7.00436 0.285976 5.57322 0.807145 4.25989L1.43146 2.68664L2.5082 3.9926C4.32827 6.20011 6.98916 7.68404 10.0002 7.95517Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-twitter-filled')
export default class LogoTwitterFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-twitter-filled',
    }
  }
}
